import { useContext } from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../components/button/button.component';
import CheckoutItem from '../../components/checkout-item/checkout-item.component';
import PageHeader from '../../components/page-header/page-header.component';
import { CartContext } from '../../contexts/cart.context';
import { formatViewNumber, scrollTop } from '../../utils/utils';
import './checkout.styles.scss';

// La cinquième colonne, celle de la croix de suppression, n'a pas d'intitulé : la
// grille lui garde sa place sans qu'on ait à poser une cellule vide.
const COLUMNS = ['Produit', 'Description', 'Quantité', 'Prix'];

const Checkout = () => {
  const { cartItems, cartTotal } = useContext(CartContext);
  const navigate = useNavigate();

  const isEmpty = cartItems.length === 0;

  const goToDelivery = () => {
    navigate('/delivery');
  };

  return (
    <div className="checkout-page">
      <PageHeader
        overline="Votre panier"
        title="Panier"
        lead={
          isEmpty
            ? 'Votre panier est vide pour le moment.'
            : `${cartItems.length} article${
                cartItems.length > 1 ? 's' : ''
              } dans votre panier.`
        }
      />

      {isEmpty ? (
        <Link className="brand-link" to="/shop" onClick={scrollTop}>
          Voir la boutique
          <span className="brand-link-arrow" aria-hidden="true">
            <BsArrowRight />
          </span>
        </Link>
      ) : (
        <>
          <div className="checkout-head">
            {COLUMNS.map((column) => (
              <span key={column}>{column}</span>
            ))}
          </div>

          {cartItems.map((cartItem) => (
            <CheckoutItem key={cartItem.id} cartItem={cartItem} />
          ))}

          <div className="checkout-total">
            <span className="checkout-total-label">Total</span>
            <span className="checkout-total-value">
              {formatViewNumber(cartTotal)} €
            </span>
          </div>

          <div className="checkout-actions">
            <Button onClick={goToDelivery}>Continuer vers l'expédition</Button>
          </div>
        </>
      )}
    </div>
  );
};

export default Checkout;
